// extracted by mini-css-extract-plugin
export default {"flash-time":"yhKEF"};